import React from "react";
// outsource
import { Row, Col, Table, TimePicker } from "antd";
import dayjs from "dayjs";

const formatTime = (t) => dayjs(t, "HH:mm").format("h:mm A");

const PayoutSettingAfterHoursTable = ({ rows, editing, onChange }) => {
  // -------------------------- VAR --------------------------
  const columns = [
    {
      title: "Branch",
      dataIndex: "branch",
      key: "branch",
      render: (val) => <span className="ps-ah-branch">{val}</span>,
    },
    {
      title: "Weekdays",
      dataIndex: "weekdays",
      key: "weekdays",
      width: 160,
      render: (val, record) =>
        editing ? (
          <TimePicker
            value={dayjs(val, "HH:mm")}
            format="h:mm A"
            use12Hours
            size="small"
            allowClear={false}
            className="ps-time-picker"
            onChange={(v) =>
              onChange(record.id, "weekdays", v ? v.format("HH:mm") : val)
            }
          />
        ) : (
          <div className="ps-time-box">{formatTime(val)}</div>
        ),
    },
    {
      title: "Weekends",
      dataIndex: "weekends",
      key: "weekends",
      width: 160,
      render: (val, record) =>
        editing ? (
          <TimePicker
            value={dayjs(val, "HH:mm")}
            format="h:mm A"
            use12Hours
            size="small"
            allowClear={false}
            className="ps-time-picker"
            onChange={(v) =>
              onChange(record.id, "weekends", v ? v.format("HH:mm") : val)
            }
          />
        ) : (
          <div className="ps-time-box">{formatTime(val)}</div>
        ),
    },
  ];

  // -------------------------- MAIN --------------------------
  return (
    <Row>
      <Col xl={24} lg={24} md={24} xs={24}>
        <Table
          columns={columns}
          dataSource={rows}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </Col>
    </Row>
  );
};

export default PayoutSettingAfterHoursTable;
